'use client';

import { RootLayoutSiteinfoFragment } from '@business/gql/graphql';
import { Dictionary } from '@ts/dictionary';
import { RichText } from '@ui/components/RichText';
import MarketSelector from '@ui/components/MarketSelector/MarketSelector';
import PaymentAndShippingLogos from './PaymentAndShippingLogos';

type Props = {
  paymentLogos: RootLayoutSiteinfoFragment['paymentImagesCollection'];
  shippingLogos: RootLayoutSiteinfoFragment['shippingImagesCollection'];
  copyright: RootLayoutSiteinfoFragment['copyright'];
  dictionary: Dictionary;
};

export default function FooterBar(props: Props) {
  const { copyright, dictionary, paymentLogos, shippingLogos } = props;
  return (
    <div className="flex flex-col items-center justify-between gap-4 bg-beige-3 py-5 lg:flex-row lg:gap-8">
      <button
        className="w-full bg-black p-6 text-sm text-white max-lg:order-3 max-lg:text-center lg:hidden"
        onClick={() =>
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }>
        {dictionary.scrollToTop}
      </button>
      <div className="flex w-full px-4 max-lg:order-last max-lg:flex-row max-lg:items-center max-lg:justify-between lg:flex-1">
        <RichText className="not-prose text-xxs" content={copyright} />
        <div className="text-xxs font-bold lg:hidden">
          <MarketSelector />
        </div>
      </div>

      {/* Desktop row */}
      {(paymentLogos || shippingLogos) && (
        <div className="flex flex-1 justify-center space-x-4 px-4 max-lg:hidden">
          <PaymentAndShippingLogos
            paymentLogos={paymentLogos}
            shippingLogos={shippingLogos}
          />
        </div>
      )}
      <div className="justify-end px-4 text-right text-xxs font-bold max-lg:hidden lg:flex lg:flex-1">
        <MarketSelector />
      </div>

      {/* Mobile row */}
      <div className="order-first flex w-full items-center justify-center whitespace-nowrap max-sm:max-w-sm max-sm:px-4 md:shrink-0 lg:hidden">
        {(paymentLogos || shippingLogos) && (
          <PaymentAndShippingLogos
            paymentLogos={paymentLogos}
            shippingLogos={shippingLogos}
          />
        )}
      </div>
    </div>
  );
}
